var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.followups},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-row',[_c('FollowUpsTableActions',{attrs:{"followup":item}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }